// MESSAGES
export const REQUIRED_FIELD = "This field is required";

// REGEX
export const REGEX_EMAIL = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$";
